// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ultimate-security-setup-wizard-wrapper {
  padding: 30px 200px;
  /* Header Styles */
  /* Footer Styles */
}
.ultimate-security-setup-wizard-wrapper .setup-wizard-header {
  background: #ffffff;
}
.ultimate-security-setup-wizard-wrapper .setup-wizard-footer {
  background: #ffffff;
}
.ultimate-security-setup-wizard-wrapper .button:focus {
  border-color: unset;
  box-shadow: unset;
}`, "",{"version":3,"sources":["webpack://./src/pages/SetupWizard/SetupWizard.scss"],"names":[],"mappings":"AAAA;EACC,mBAAA;EAEA,kBAAA;EAKA,kBAAA;AAJD;AAAC;EACG,mBAAA;AAEJ;AAEC;EACC,mBAAA;AAAF;AAGC;EACC,mBAAA;EACA,iBAAA;AADF","sourcesContent":[".ultimate-security-setup-wizard-wrapper {\n\tpadding: 30px 200px;\n\t\n\t/* Header Styles */\n\t.setup-wizard-header {\n    background: #ffffff;\n\t}\n\n\t/* Footer Styles */\n\t.setup-wizard-footer {\n\t\tbackground: #ffffff;\n\t}\n\n\t.button:focus {\n\t\tborder-color: unset; \n\t\tbox-shadow: unset; \n\t}\n\t\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
